// Side controls for cycling avatar eye and mouth expressions.

import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { cn } from '@/utilities/cn';

interface AvatarSideRailsProps {
  onCycleEyes: (direction: 'prev' | 'next') => void;
  onCycleMouth: (direction: 'prev' | 'next') => void;
}

const AvatarSideRails: React.FC<AvatarSideRailsProps> = ({
  onCycleEyes,
  onCycleMouth,
}) => {
  return (
    <div className="pointer-events-none absolute inset-y-0 left-[4%] right-[4%] z-30 sm:left-[5%] sm:right-[5%] md:left-[4%] md:right-[4%]">
      {(['left', 'right'] as const).map((side) => {
        const isLeft = side === 'left';
        const Icon = isLeft ? ChevronLeft : ChevronRight;
        const direction = isLeft ? 'prev' : 'next';
        const labelPrefix = isLeft ? 'Previous' : 'Next';

        return (
          <div
            key={side}
            className={cn(
              'pointer-events-auto absolute inset-y-0 flex w-10 flex-col items-center sm:w-12 md:w-16',
              isLeft ? 'left-0' : 'right-0'
            )}
          >
            <button
              type="button"
              onClick={() => onCycleEyes(direction)}
              className="absolute top-[37%] -translate-y-1/2 cursor-pointer text-muted-foreground transition-colors hover:text-primary focus-visible:ring-3 focus-visible:ring-ring/50 focus-visible:outline-none"
              aria-label={`${labelPrefix} eye shape`}
            >
              <Icon className="size-12 sm:size-14 md:size-16" />
            </button>
            <button
              type="button"
              onClick={() => onCycleMouth(direction)}
              className="absolute top-[63%] -translate-y-1/2 cursor-pointer text-muted-foreground transition-colors hover:text-primary focus-visible:ring-3 focus-visible:ring-ring/50 focus-visible:outline-none"
              aria-label={`${labelPrefix} mouth shape`}
            >
              <Icon className="size-12 sm:size-14 md:size-16" />
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default AvatarSideRails;
